import * as _ from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import './SalariesList.scss';
import DocumentCards from '../../../../document-cards';

const SalariesList = (props) => {
  const { salaries, filterValue } = props;
  const { t, i18n } = useTranslation();

  const filteredAndSortedSalaries = useMemo(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1-12
    const lastYear = currentYear - 1;

    const salaryByKey = _(salaries)
      .filter((s) => s.year && s.month)
      .keyBy((s) => `${s.year}-${s.month}`)
      .value();

    const result = [];
    // Current year: months before the current month only.
    for (let month = currentMonth - 1; month >= 1; month--) {
      const key = `${currentYear}-${month}`;
      result.push(
        salaryByKey[key] ?? {
          id: `empty-${key}`,
          year: currentYear,
          month,
          monthly_overview_file_link: null,
          monthly_file_name: null,
          salary_file_link: null,
          salary_file_name: null,
        }
      );
    }
    
    // Last year: all 12 months
    for (let month = 12; month >= 1; month--) {
      const key = `${lastYear}-${month}`;
      result.push(
        salaryByKey[key] ?? {
          id: `empty-${key}`,
          year: lastYear,
          month,
          monthly_overview_file_link: null,
          monthly_file_name: null,
          salary_file_link: null,
          salary_file_name: null,
        }
      );
    }

    return result;
  }, [salaries]);

  return <DocumentCards data={filteredAndSortedSalaries} docType="salary" />;
};

export { SalariesList }; 
